import React, { Fragment } from "react";
import "./styles.scss";
import "@near-wallet-selector/account-export/styles.css";

import Content from "./components/Content";
import { WalletSelectorContextProvider } from "./contexts/WalletSelectorContext";

const App: React.FC = () => {
  return (
    <Fragment>
      <h1>NEAR Guest Book</h1>
      <WalletSelectorContextProvider>
        <Content />
      </WalletSelectorContextProvider>
    </Fragment>
  );
};

export default App;
